import $ from 'jquery'

export class CgvCategories {

  constructor($container)
  {
			// this.$cgv_categories = $container.find('.cgv-categories-cgv-categories')
  }

}
